var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-button"},[_c('f7-fab',{attrs:{"slot":"fixed","position":"right-bottom"},on:{"click":function($event){return _vm.$emit('click')}},slot:"fixed"},[_c('f7-icon',{attrs:{"ios":`f7:${_vm.type}`,"md":`material:${_vm.type}`}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }